import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'labelKeyMore', pure: false,
    standalone: false
})
export class LabelKeyMorePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(label: string, value: any): string {
    if (Number(value) >= 5) {
      const moreKey = `${label}_more`;
      if (this.translate.instant(moreKey) !== moreKey) {
        return moreKey;
      }
    }
    return label;
  }
}

@NgModule({
  declarations: [LabelKeyMorePipe],
  exports: [LabelKeyMorePipe],
})
export class LabelKeyMorePipeModule {}
